import { Text, TextProps, Tooltip } from '@chakra-ui/react'

interface TableCellIProps extends TextProps {
  label: string
  tooltipLabel?: string
  dataTestId?: string
}

export const TableCell = ({
  label,
  tooltipLabel = label,
  dataTestId,
  ...styles
}: TableCellIProps) => {
  return (
    <Tooltip hasArrow label={tooltipLabel} openDelay={500} placement='auto'>
      <Text
        color='black'
        data-testid={dataTestId}
        fontWeight={500}
        isTruncated
        {...styles}
      >
        {label}
      </Text>
    </Tooltip>
  )
}
